export const ObjectImmobilizer = Object.freeze({
    REQUESTED_AT: 'requestedAt',
    REQUESTER_USER_ID: 'requesterUserId',
    STATE: 'state'
})
